"use client";

import { SectionBadge } from "./SectionBadge";
import { useI18n } from "@/i18n/context";

export function IdentitySection() {
  const { t } = useI18n();

  return (
    <section id="identity" className="relative bg-bg-warm py-[83px] px-8">
      <div className="mb-[80px]" data-reveal>
        <SectionBadge>{t.identity.badge}</SectionBadge>
      </div>

      <h2 data-reveal className="font-clash font-bold text-[38px] text-[#2f2f2f] text-center uppercase tracking-[2.66px] leading-normal max-w-[1320px] mx-auto mb-[48px] whitespace-pre-line">
        {t.identity.title}
      </h2>

      <div data-reveal data-reveal-stagger className="font-besley text-[24px] text-text-secondary text-center tracking-[1.68px] leading-[28px] max-w-[776px] mx-auto space-y-[28px]">
        {t.identity.lines.map((line, i) => (
          <p key={i} className="whitespace-pre-line">
            {line}
          </p>
        ))}
      </div>
    </section>
  );
}
